import { useTranslation } from "react-i18next";
import nxI18n from "./i18n";
import { useMemo } from "react";
export function useNxTranslation() {
    const t = useTranslation();
    return useMemo(() => {
        return {
            t: (key, optionsAndInterpolationMap) => t.t(key, optionsAndInterpolationMap),
            nxI18n,
        };
    }, [t.t]);
}
//# sourceMappingURL=useNxTranslation.js.map